module.exports = __webpack_public_path__ + "static/media/twitter.d02e8f4e.svg";